module.exports = __webpack_public_path__ + "img/Studio A.35f6eb1d.jpg";